import { observer, Provider } from "mobx-react";
import * as React from "react";
import { DocumentListBody } from "../Document/DocumentList";
import { RecentFilesUIStore } from "../Stores/RecentFilesUIStore";

export interface IRecentFileProps {
	number: number;
	className?: string;
}

@observer
export class RecentFileList extends React.Component<IRecentFileProps, {}> {


	store: RecentFilesUIStore = new RecentFilesUIStore();

	componentDidMount() {
		this.store.showCount = this.props.number;
		this.store.showOnlyName = true;
		this.store.triggerSearch();
	}

	componentDidUpdate() {
		this.store.showCount = this.props.number;
		this.store.showOnlyName = true;
		this.store.triggerSearch();
	}

	render() {
		return <Provider store={this.store}>
			<div className={`list-advanced ${this.props.className}`} data-test-id="recentFileList">
				<table>
					<DocumentListBody showValidities={false} />
				</table>
			</div>
		</Provider>;
	}
}
